import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import TextInput from 'screens/components/basic/TextInput';
import Panel from 'screens/components/basic/Panel';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import WithRouter from 'custom/withRouter';

class HowtoContent extends Component {
    constructor(props) {
        super(props);
    }

    editHowTo = () => {
        this.props.navigate('/admin/writing/how-to/edit');
    }

    getHowTo = () => {
        return (
            [
                {
                    title: "How to Make Your First Order",
                    status: "Active",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.editHowTo()}
                            />
                        </div>
                    )
                },
                {
                    title: "How to Send Payment",
                    status: "Active",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.editHowTo()}
                            />
                        </div>
                    )
                }
            ]
        );
    }

    render() {
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active"><Link to={LOOKUP.menu.admin.writing.howTo.link}>{LOOKUP.menu.admin.writing.howTo.text}</Link></li>
                </ol>
                <h2>{LOOKUP.menu.admin.writing.howTo.text}</h2>
            </div>
        );

        const sideContent = (
            <Panel title="Toolbox">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center margin_button">
                    <Button name="buttonSave"
                        className="toolbox-button"
                        label={LOOKUP.menu.admin.writing.howTo.add.label}
                        primary={true}
                        onTouchTap={() => this.editHowTo()} />
                </div>
            </Panel>
        );

        return (
            <div>
                <ContainerDivided headerContent={header} sideContent={sideContent}>
                    <GenericTable
                        className="table_center"
                        tableBodyClassName="table_center"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={true}
                        columns={LOOKUP.menu.admin.writing.howTo.tableColumns}
                        rows={this.getHowTo()}
                        stripedRows={true}
                    />
                </ContainerDivided>
            </div>
        );
    }
}


export default WithRouter(HowtoContent);